import React, { forwardRef, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import useControlled from '../../utils/useControlled'
import withTheme from '../styles/withTheme'

import './rf-switch.scss'

const Switch = forwardRef(function Switch(props, ref) {
	const {
		checked: checkedProp,
		className,
		defaultChecked,
		disabled,
		onChange,
		onCheckedChange,
		orientation = 'horizontal',
		...other
	} = props

	const inputRef = useRef()

	const handleChange = () => {
		if (disabled) {
			return
		}
		const newChecked = !inputRef.current.checked
		onCheckedChange && onCheckedChange(newChecked)
		onChange && onChange(newChecked)
		inputRef.current.checked = newChecked
	}

	useEffect(() => {
		if (disabled) {
			return
		}
		inputRef.current.checked = checkedProp
	}, [checkedProp])

	return (
		<span
			ref={ref}
			className={clsx(
				'Vb-rf-switch',
				`Vb-rf-switch__${orientation}`,
				disabled && `Vb-rf-switch--disabled`,
				className
			)}
		>
			<span className="toggle-outside" onClick={handleChange}>
				<input ref={inputRef} type="checkbox" disabled={disabled} {...other} />
				<span className="toggle-inside"></span>
			</span>
		</span>
	)
})

export default withTheme('Vb-rf-switch')(Switch)

Switch.propTypes = {
	/**
	 * extend the styles applied to the component
	 */
	className: PropTypes.string,

	/**
	 * If `true`, the switch is disabled.
	 * @default false
	 */
	disabled: PropTypes.bool,

	/**
	 * Callback fired when the state is changed.
	 *
	 * @param {object} event The event source of the callback.
	 * You can pull out the new value state by accessing `value` (any).
	 */
	onChange: PropTypes.func,

	/**
	 * the type of component orientation.
	 * @default 'horizontal'
	 */
	orientation: PropTypes.oneOf(['horizontal', 'vertical'])
}
